import {
  US_STATES_EXCLUDED_FROM_MENU,
  US_STATES_LIST
} from '@/domain/location/constants'

type NavLink = {
  name: string
  link: string
}

interface MobileMenuLinks extends Record<string, NavLink[]> {
  Canada: NavLink[]
  Europe: NavLink[]
  Australia: NavLink[]
  'Latin America': NavLink[]
  Africa: NavLink[]
  Asia: NavLink[]
}

export type USStateMenu = Omit<
  typeof US_STATES_LIST,
  (typeof US_STATES_EXCLUDED_FROM_MENU)[number]
>
export const FILTERED_US_STATES = US_STATES_LIST.filter(
  (state) => !US_STATES_EXCLUDED_FROM_MENU.includes(state)
) as USStateMenu

export const WORLDWIDE_MENU_LINKS: MobileMenuLinks = {
  Canada: [
    {
      name: 'British Columbia',
      link: '/british-columbia/'
    },
    {
      name: 'Ontario',
      link: '/ontario/'
    },
    {
      name: 'Montreal',
      link: '/montreal/'
    },
    {
      name: 'Calgary',
      link: '/calgary/'
    }
  ],
  Europe: [
    {
      name: 'United Kingdom',
      link: '/united-kingdom/'
    },
    {
      name: 'Spain',
      link: '/spain/'
    },
    {
      name: 'Switzerland',
      link: '/switzerland/'
    },
    {
      name: 'Greece',
      link: '/greece/'
    }
  ],
  Australia: [
    {
      name: 'Queensland',
      link: '/queensland/'
    },
    {
      name: 'Victoria',
      link: '/victoria/'
    }
  ],
  'Latin America': [
    {
      name: 'Costa Rica',
      link: '/costa-rica/'
    },
    {
      name: 'Panama',
      link: '/panama/'
    }
  ],
  Africa: [
    {
      name: 'Tunisia',
      link: '/tunisia/'
    },
    {
      name: 'South Africa',
      link: '/south-africa/'
    }
  ],
  Asia: [
    {
      name: 'Bali',
      link: '/bali/'
    },
    {
      name: 'India',
      link: '/india/'
    },
    {
      name: 'Malaysia',
      link: '/malaysia/'
    },
    {
      name: 'Thailand',
      link: '/thailand/'
    }
  ]
}

export const linksNav = [
  {
    name: 'Location',
    link: '/locations/',
    header: 'Locations',
    topLocations: [
      {
        name: 'Africa',
        locations: [
          {
            name: 'Tunisia',
            link: '/tunisia/'
          },
          {
            name: 'South Africa',
            link: '/south-africa/'
          }
        ]
      },
      {
        name: 'Asia',
        locations: [
          {
            name: 'Bali',
            link: '/bali/'
          },
          {
            name: 'India',
            link: '/india/'
          },
          {
            name: 'Malaysia',
            link: '/malaysia/'
          },
          {
            name: 'Thailand',
            link: '/thailand/'
          }
        ]
      },
      {
        name: 'Australia',
        locations: [
          {
            name: 'Queensland',
            link: '/queensland/'
          },
          {
            name: 'Victoria',
            link: '/victoria/'
          }
        ]
      },
      {
        name: 'Latin America',
        locations: [
          {
            name: 'Costa Rica',
            link: '/costa-rica/'
          },
          {
            name: 'Panama',
            link: '/panama/'
          }
        ]
      },
      {
        name: 'Europe',
        locations: [
          {
            name: 'United Kingdom',
            link: '/united-kingdom/'
          },
          {
            name: 'Spain',
            link: '/spain/'
          },
          {
            name: 'Switzerland',
            link: '/switzerland/'
          },
          {
            name: 'Greece',
            link: '/greece/'
          }
        ]
      },
      {
        name: 'Canada',
        locations: [
          {
            name: 'British Columbia',
            link: '/british-columbia/'
          },
          {
            name: 'Ontario',
            link: '/ontario/'
          },
          {
            name: 'Montreal',
            link: '/montreal/'
          },
          {
            name: 'Calgary',
            link: '/calgary/'
          }
        ]
      },
      {
        name: 'United States',
        locations: [
          {
            name: 'Arizona',
            link: '/arizona/'
          },
          {
            name: 'California',
            link: '/california/'
          },
          {
            name: 'Florida',
            link: '/florida/'
          },
          {
            name: 'Midwest',
            link: '/midwest/'
          },
          {
            name: 'Texas',
            link: '/texas/'
          },
          {
            name: 'Nevada',
            link: '/nevada/'
          },
          {
            name: 'Utah',
            link: '/utah/'
          },
          {
            name: 'Virginia',
            link: '/virginia/'
          },
          {
            name: 'Colorado',
            link: '/colorado/'
          },
          {
            name: 'New Jersey',
            link: '/new-jersey/'
          }
        ]
      }
    ],
    items: [
      {
        name: 'Malibu',
        src: 'https://res.cloudinary.com/rehabpath/image/upload/c_lfill,q_30,f_auto,h_800,w_1600/g3p7db91iwwqchap7yin',
        link: '/malibu/'
      },
      {
        name: 'Los Angeles',
        src: 'https://res.cloudinary.com/rehabpath/image/upload/c_lfill,q_30,f_auto,h_800,w_1600/wmx9pyln1hxhqzc96bde',
        link: '/los-angeles/'
      },
      {
        name: 'Miami',
        src: 'https://res.cloudinary.com/rehabpath/image/upload/c_lfill,q_30,f_auto,h_800,w_1600/xpi0zvhhiqr4271zqnkq',
        link: '/miami/'
      },
      {
        name: 'San Diego',
        src: 'https://res.cloudinary.com/rehabpath/image/upload/c_lfill,q_30,f_auto,h_800,w_1600/q6rmk0ye6s1otyg868fu',
        link: '/san-diego/'
      },
      {
        name: 'Colorado',
        src: 'https://res.cloudinary.com/rehabpath/image/upload/c_lfill,q_30,f_auto,h_800,w_1600/uw9jfhdckedmpsqdncqb',
        link: '/colorado/'
      },
      {
        name: 'Texas',
        src: 'https://res.cloudinary.com/rehabpath/image/upload/c_lfill,q_30,f_auto,h_800,w_1600/d1lwtfrjjozuafz5gr9d',
        link: '/texas/'
      }
    ]
  }
]

export const TREATMENT_METHODS_LINKS = {
  name: 'Treatment Methods',
  link: '/approach/',
  itemGroups: {
    'Treatment Approach': [
      {
        name: 'Evidence-Based',
        link: '/approach/evidence-based/'
      },
      {
        name: 'Holistic',
        link: '/approach/holistic/'
      },
      {
        name: 'Wellness',
        link: '/approach/wellness/'
      },
      {
        name: '12 Step',
        link: '/approach/twelve-step/'
      },
      {
        name: 'Non-12 Step',
        link: '/approach/non-12-step/'
      }
    ],
    Therapies: [
      {
        name: 'Art Therapy',
        link: '/activities/art-therapy/'
      },
      {
        name: 'EMDR',
        link: '/therapies/eye-movement-desensitization-and-reprocessing/'
      },
      {
        name: 'Equine Therapy',
        link: '/therapies/equine-therapy/'
      },
      {
        name: 'Mindfulness-Based Cognitive Therapy',
        link: '/therapies/mbct/'
      },
      {
        name: 'Yoga',
        link: '/therapies/yoga/'
      }
    ]
  }
}

export const AMENITIES_AND_SETTINGS_LINKS = {
  name: 'Amenities and Settings',
  link: '/amenities/',
  itemGroups: {
    Amenities: [
      {
        name: 'Beachfront',
        link: '/amenities/beachfront/'
      },
      {
        name: 'Luxury',
        link: '/amenities/luxury/'
      },
      {
        name: 'Pet-Friendly',
        link: '/amenities/pet-friendly/'
      },
      {
        name: 'Private',
        link: '/amenities/private/'
      },
      {
        name: 'Secluded',
        link: '/amenities/secluded/'
      }
    ],
    Settings: [
      {
        name: 'Desert',
        link: '/settings/desert/'
      },
      {
        name: 'Mountain',
        link: '/settings/mountain/'
      },
      {
        name: 'Oceanfront',
        link: '/settings/oceanfront/'
      },
      {
        name: 'Rural',
        link: '/settings/rural/'
      },
      {
        name: 'Urban',
        link: '/settings/urban/'
      }
    ]
  }
}

export const CLIENTELE_LINKS = {
  name: 'Clientele',
  link: '',
  items: [
    {
      name: 'Executives',
      link: '/clientele/executives/'
    },
    {
      name: 'Men',
      link: '/clientele/men/'
    },
    {
      name: 'Teens',
      link: '/clientele/adolescents/'
    },
    {
      name: 'Women',
      link: '/clientele/women/'
    },
    {
      name: 'LGBTQ+',
      link: '/clientele/lgbtq/'
    },
    {
      name: 'Young Adults',
      link: '/clientele/young-adults/'
    },
    {
      name: 'Children',
      link: '/clientele/children/'
    },
    {
      name: 'Pregnant Women',
      link: '/clientele/pregnant-women/'
    },
    {
      name: 'Older Adults',
      link: '/clientele/older-adults/'
    },
    {
      name: 'Veterans',
      link: '/clientele/veterans/'
    },
    {
      name: 'Christians',
      link: '/approach/christian/'
    },
    {
      name: 'Couples',
      link: '/clientele/couples/'
    }
  ]
}

export const CONDITIONS_TREATED_LINKS = {
  name: 'Conditions',
  link: '/condition/',
  items: [
    {
      name: 'Addiction',
      link: '/united-states/'
    },
    {
      name: 'Depression',
      link: '/condition/depression/'
    },
    {
      name: 'Eating Disorders',
      link: '/condition/eating-disorders/'
    },
    {
      name: 'Trauma',
      link: '/condition/trauma/'
    },
    {
      name: 'Anxiety',
      link: '/condition/anxiety/'
    },
    {
      name: 'Bipolar',
      link: '/condition/bipolar/'
    }
  ]
}

export const PRICE_LINKS = {
  name: 'Price',
  link: '/price/',
  items: [
    {
      name: 'Budget',
      link: '/price/budget/'
    },
    {
      name: 'Affordable',
      link: '/price/affordable/'
    },
    {
      name: 'Upscale',
      link: '/price/upscale/'
    },
    {
      name: 'Premium',
      link: '/price/premium/'
    }
  ]
}

export const LEVELS_OF_CARE_LINKS = {
  name: 'Levels of Care',
  link: '/care/',
  items: [
    {
      name: 'Detox',
      link: '/care/detox/'
    },
    {
      name: 'Residential Rehab',
      link: '/united-states/'
    },
    {
      name: 'Sober Living',
      link: '/care/sober-living/'
    },
    {
      name: 'Outpatient',
      link: '/care/outpatient/'
    },
    {
      name: 'Intensive Outpatient',
      link: '/care/intensive-outpatient-program/'
    },
    {
      name: 'Virtual',
      link: '/care/virtual/'
    },
    {
      name: 'In-Home',
      link: '/care/in-home/'
    }
  ]
}

export const INSURANCE_NAV_LINKS = {
  name: 'Insurance',
  link: '/insurance/',
  items: [
    {
      name: 'Aetna',
      link: '/insurance/aetna/'
    },
    {
      name: 'Anthem',
      link: '/insurance/anthem/'
    },
    {
      name: 'BlueCross Blueshield',
      link: '/insurance/bluecross-blueshield/'
    },
    {
      name: 'Cigna',
      link: '/insurance/cigna/'
    },
    {
      name: 'Humana',
      link: '/insurance/humana/'
    },
    {
      name: 'United Healthcare',
      link: '/insurance/united-healthcare/'
    }
  ]
}

export const enum Containers {
  TREATMENT_METHODS = 'Treatment Methods',
  AMENITIES_AND_SETTINGS = 'Amenities and Settings',
  CLIENTELE = 'Clientele',
  CONDITIONS = 'Conditions',
  WORLDWIDE = 'Worldwide',
  UNITED_STATES = 'United States',
  INSURANCE = 'Insurance',
  LEVELS_OF_CARE = 'Levels of Care',
  SETTINGS = 'Settings',
  RESOURCE_HUB = 'Resource Hub',
  ABOUT_US = 'About Us',
  OUR_CRITERIA = 'Our Criteria',
  FOR_TREATMENT_PROVIDERS = 'For Treatment Providers',
  CAREERS = 'Careers',
  CONTACT_US = 'Contact Us',
  CLAIM_PROFILE = 'Claim Profile'
}

export const MOBILE_MENU_LINKS = {
  [Containers.TREATMENT_METHODS]: TREATMENT_METHODS_LINKS,
  [Containers.AMENITIES_AND_SETTINGS]: AMENITIES_AND_SETTINGS_LINKS,
  [Containers.CLIENTELE]: CLIENTELE_LINKS,
  [Containers.WORLDWIDE]: WORLDWIDE_MENU_LINKS,
  [Containers.CONDITIONS]: CONDITIONS_TREATED_LINKS,
  [Containers.LEVELS_OF_CARE]: LEVELS_OF_CARE_LINKS,
  [Containers.INSURANCE]: INSURANCE_NAV_LINKS
}

export const RESOURCE_HUB_TEXT =
  'Researched, fact-checked and transparent articles and guides that offer addiction and mental health insight from experts and treatment professionals.'
export const ABOUT_US_TEXT =
  'Recovery.com combines independent research with expert guidance on addiction and mental health treatment. Our mission is to help everyone find the best path to recovery through the most comprehensive, helpful network of treatment providers worldwide.'

export const LEARN_MENU_TEXT =
  'The search for addiction and mental health treatment can be overwhelming. We created this guide to support you in finding treatment that meets your needs.'

export const OUR_CRITERIA_TEXT =
  'We list any treatment center that meets our rehab criteria, giving you the best list of options possible when looking for treatment.'
export const CLAIMED_VERIFY_TEXT =
  'Recovery.com uses a standard procedure to make sure treatment provider profiles on our site are current and complete. We do this by claiming or verifying profiles.'

export const FOR_TREATMENT_PROVIDERS_TEXT =
  'Every month, 150,000 people search for addiction or mental health treatment on Recovery.com. Let us help them find you. '

export const CLAIM_PROFILE_TEXT =
  'The best way to manage your provider profile on Recovery.com is by claiming it. It’s an easy, free way to better promote your center to those in need.'

export const CAREERS_TEXT =
  'Join our global mission of connecting patients with addiction and mental health treatment. See open positions and help people step into hope.'

export const CONTACT_US_TEXT =
  'If you’re a treatment provider and have a question, please reach out and someone from our Customer Success team will be in touch with you shortly.'

export const FOR_TREATMENT_SEEKERS_TEXT =
  "If you're looking for treatment, please browse the site to reach out to treatment centers directly."
